import axios from 'axios';
import Cookies from 'js-cookie'
import AccessToken from '@/services/auth-central';
import { store } from '@/vuex-store';
import { gotoLoginGoSaas } from "@/settings";
import signature  from '@/services/signature';
const ACCESS_TOKEN = AccessToken();

const BASE_URI = process.env.API_BASE_URI;
const GOCHAT_URL = process.env.API_URL;
const GOSAAS_URL = process.env.G0SAAS_API_BASE_URL;
// console.log(GOCHAT_URL,'GOCHAT_URL----');
const GOCHAT_TOKEN = ACCESS_TOKEN.token || Cookies.get('centralToken');

let config = {
  timeout: 10000,
  headers: {
    Authorization: `Bearer ${AccessToken().token}`,
  }
}

// /v2/chats ฝั่ง backend ตัดเองที่ maxTimeMS 15 วิ แล้วตอบ 503 พร้อมข้อความภาษาไทย
// ถ้า client ตัดที่ 10 วิเหมือน config กลาง ข้อความนั้นจะไม่มีวันถึงหน้าจอเลย
// ตั้งไว้ 20 วิ ให้ยาวกว่าฝั่ง server เพื่อให้ได้ 503 มาแสดงจริง
let chatListConfig = {
  timeout: 20000,
  headers: {
    Authorization: `Bearer ${AccessToken().token}`,
  }
}

let uploadConfig = {
  timeout: 60000,
  headers: {
    Authorization: `Bearer ${AccessToken().token}`,
  }
}

// createOrder ยิงไป GoSaaS ซึ่งบางเคสประมวลผลนาน (WMS/shipment) — ฝั่ง gochat-nodejs
// ตั้ง axios timeout 30 วิ ต่อ 1 attempt. ถ้า client ใช้ config กลาง (timeout 10 วิ) จะตัดก่อน
// server ตอบเสมอ → เข้า catch → ขึ้น error แดง ทั้งที่ออเดอร์กำลังถูกสร้างจริง (ปัญหาที่ลูกค้าแจ้ง)
// ตั้ง 35 วิ ให้ยาวกว่า first-attempt ของ server เล็กน้อย เพื่อให้ออเดอร์ที่สำเร็จภายใน ~30 วิ
// ได้รับผล success จริง (ไม่ต้องไปเช็คเอง) ส่วนเคสที่ช้ากว่านั้นจะตกเป็น pending ใน catch
let createOrderConfig = {
  timeout: 35000,
  headers: {
    Authorization: `Bearer ${AccessToken().token}`,
  }
}

// console.log("Cookies: ", AccessToken(), Cookies.get('centralToken'))

class Address {
  async getAddressJson() {
    return await axios.get(BASE_URI + '/v1/address-json', config);
  }

  async spreadAddress(text) {
    return await axios.get(GOCHAT_URL + '/v2/service/spread-address', { params: { text }, headers: config.headers });
  }

  async getAddress() {
    return await axios
      .get(GOCHAT_URL + '/v2/address', config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
}

class Merchant {
  async getMerchantDetail(merchatID, token) {
    return await axios
      .get(GOCHAT_URL + `/v2/merchantDetail/${merchatID}`, token ? {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      } : config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getVatSetting(merchatID) {
    return await axios
      .get(GOCHAT_URL + `/v2/merchantDetail/${merchatID}/vat`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
}

class FrequentlyMsg {
  async getFrequentlyMsgList(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/chat/message/frequently/list', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getFrequentlyMsg(data) {
    return await axios
      .get(GOCHAT_URL + `/v2/chat/message/frequently/${data}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async uploadNewFrequentlyMsg(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/chat/message/frequently', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async updateFrequentlyMsg(data) {
    return await axios
      .put(GOCHAT_URL + '/v2/chat/message/frequently', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async deleteFrequentlyMsg(data) {
    return await axios
      .delete(GOCHAT_URL + `/v2/chat/message/frequently/${data}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async toggleFrequentlyMsgStatus(id, is_active) {
    return await axios
      .patch(GOCHAT_URL + `/v2/chat/message/frequently/${id}/status`, { is_active }, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async toggleFrequentlyMsgFavorite(id, is_favorite) {
    return await axios
      .patch(GOCHAT_URL + `/v2/chat/message/frequently/${id}/favorite`, { is_favorite }, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async updateMode(data) {
    return await axios
      .put(GOCHAT_URL + '/v2/chat/message/frequently/setting/mode', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async copyMessages(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/chat/message/frequently/copy', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getAuditLog(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/chat/message/frequently/audit/list', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
}

class Product {
  async getProductList(data) {
    // console.log(data, 'data---2--');
    return await axios
      .post(GOCHAT_URL + '/v2/product', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getProductDetail(merchatID, productID) {
    return await axios
      .get(GOCHAT_URL + `/v2/product/${merchatID}/${productID}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getOrderProduct(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/product/select', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  // M28: สินค้าในโปรโมชั่น (sections standard/gift) — ใช้ตอนกด Apply โปรในฟอร์มสร้างออเดอร์
  async getPromotionProducts(id) {
    return await axios
      .get(GOCHAT_URL + '/v2/product/promotion/' + id + '/products', config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }

  async getProductSummary(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/product/summary', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }

  async getVariation(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/product/config', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }

  async getProductSet(productID) {
    return await axios
      .get(GOCHAT_URL + `/v2/product/set/${productID}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
}

class Chat {
  async getPages(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/pages/list', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async getChats(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/chats', data, chatListConfig)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async getFilterItems(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/chats/filteritems', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async getChatMessages(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/chat/message', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getCustomerMessages(customerId, countMessage) {
    return await axios
      .get(GOCHAT_URL + `/v2/customers/${customerId}/chats?offset=${countMessage}`, config)
      .catch(error => {
          throw error;
      });
  }
  async resendChatMessage(selectedChat, data, messageObj) {
    const messageId = messageObj._id;
    // console.log({selectedChat, ...data, sender_name, sender_image, messageId})
    // store.dispatch('setSendingMessageAction', {selectedChat, ...data, sender_name, sender_image, messageId});
    return await axios
      .post(GOCHAT_URL + `/v2/chats/message/${messageId}/resend`, data, config)
      .then(res => {
        return res
      })
      .catch(error => {
        // store.dispatch('setSendedMessageAction', {...error, messageId, status : 500})
        throw error;
      });
  }
  async deleteResendChatMessage(messageObj) {
    const messageId = messageObj._id;
    return await axios
      .delete(GOCHAT_URL + `/v2/chats/message/${messageId}`, config)
      .then(res => {
        return res
      })
      .catch(error => {
        throw error;
      });
  }
  async sendChatMessage(selectedChat, {message_id = null, ...data}, {first_name, image_profile}) {
    const messageId = message_id || `${new Date().getTime()}${Math.floor(Math.random() * (999 - 100 + 1)) + 100}` 
    store.dispatch('setSendingMessageAction', {selectedChat, ...data, sender_name : first_name, sender_profile : image_profile, messageId});
    return await axios
      .post(GOCHAT_URL + '/v2/chats/message/new', data, config)
      .then(res => {
        store.dispatch('setSendedMessageAction', {...res, messageId, status : 200})
        return res
      })
      .catch(error => {
        store.dispatch('setSendedMessageAction', {...error, messageId, status : 500})
        throw error;
      });
  }
  async readChatMessage(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/chats/message/message_read', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getAssignees(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/list/user', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getAllCustomer(data) {
    return await axios
      .post(GOCHAT_URL + `/v2/customers/list`, data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getCustomerDetail(customerId) {
    return await axios
      .get(GOCHAT_URL + `/v2/customers/${customerId}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async updateCustomerDetail(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/customers', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async updateChatStatus(data) {
    return await axios
      .put(GOCHAT_URL + '/v2/chats/status', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async updateChatAssignee(data) {
    return await axios
      .put(GOCHAT_URL + '/v2/chats/assign', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async toggleAiAutoReply(data) {
    return await axios
      .put(GOCHAT_URL + '/v2/chats/ai/toggle', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getActivity(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/chat/activity', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  // async updateMerchant(data) {
  //     return await axios.put(GOCHAT_URL + '/v2/service/merchant/update', data, config);
  // }
  async uploadPicFile(data) {
    uploadConfig.headers = {
      ...uploadConfig.headers,
      // 'Content-Type': 'multipart/form-data',
    }
    // console.log(uploadConfig);
    return await axios
      .post(GOCHAT_URL + '/v2/pic/upload', data, uploadConfig)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }

  async deletePicFile(data) {
    return await axios
      .delete(GOCHAT_URL + `/v2/pic/${data}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }

  async uploadAttachFile(data) {
    uploadConfig.headers = {
      ...uploadConfig.headers,
      'Content-Type': 'multipart/form-data',
    }
    // console.log(uploadConfig);
    return await axios
      .post(GOCHAT_URL + '/v2/file/upload', data, uploadConfig)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }

  async deleteAttachFile(data) {
    return await axios
      .delete(GOCHAT_URL + `/v2/file/${data}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }

  async getProductList(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/product', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async getOrderList(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/order/list', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async createOrder(data) {
    // ใช้ createOrderConfig (timeout 35 วิ) แทน config กลาง (10 วิ) — ดูเหตุผลที่ประกาศ createOrderConfig
    return await axios
      .post(GOCHAT_URL + '/v2/order', data, createOrderConfig)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async isDuplicate(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/order/is-duplicate', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async getCarriersList(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/carrier/list', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  // ตารางค่าส่งของชุดที่ร้านตั้งเป็นค่าเริ่มต้น (ตามน้ำหนัก / ตามจำนวนชิ้น / เหมาจ่าย)
  async getShippingRate(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/carrier/shipping-rate', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getStaffList(data) {
    return await axios
      .get(GOCHAT_URL + `/v2/staff?name=${data}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async getDeletionList(page, limit) {
    return await axios
      .get(GOCHAT_URL + `/v2/deletion?page=${page}&limit=${limit}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async postZentryApiLead(data, customerID) {
    return await axios
      .post(GOCHAT_URL + '/v2/zentry-api/lead/' + customerID, data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
}

class Note {
  async getAllNotes(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/note/list', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async getNote(data) {
    return await axios
      .get(GOCHAT_URL + `/v2/note/${data}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async createNewNote(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/note', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async updateNote(data) {
    return await axios
      .put(GOCHAT_URL + '/v2/note', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async deleteNote(data) {
    return await axios
      .delete(GOCHAT_URL + `/v2/note/${data}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
}

class PaymentMethods {
  async getPaymentMethods(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/paymentmethod/list', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
}

class Bank {
  async getBanks(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/bank/list', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
}

class Tags {
  async getAllTags(method, data) {
    return await axios
      .get(GOCHAT_URL + `/v2/${method}/tag/${data}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
  async updateCustomerTags(customerID, data) {
    return await axios
      .put(GOCHAT_URL + `/v2/customers/${customerID}/tag`, data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
}

class LinkDetails {
  async getLinkDetails(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/link-preview', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
}
class Facebook {
  async callFacebookConversion(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/conversion/order', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
}
class ConversionAPIReport {
  async getConversionAPIReports(data) {
    return await axios
      .get(GOCHAT_URL + '/v2/conversion-api-reports' + data , config)
      .catch(error => {
        throw error.message;
      });
  }

  async retryConversionAPIReports(data) {
    return await axios
      .post(GOCHAT_URL + `/v2/conversion-api-reports/retry/${data}`, null , config)
      .catch(error => {
        throw error.message;
      });
  }

  async getConversionDataSetList(data) {
    return await axios
      .get(GOCHAT_URL + '/v2/settings/facebook-conversion' + data , config)
      .catch(error => {
        throw error.message;
      });
  }

  async updateConversionDataSetList(data) {
    return await axios
      .put(GOCHAT_URL + '/v2/settings/facebook-conversion', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }

  async updateConversionToDataSetList(pageId, data) {
    return await axios
      .put(GOCHAT_URL + `/v2/settings/facebook-conversion/${pageId}`, data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }

  async getFacebookCommentSetting() {
    return await axios
      .get(GOCHAT_URL + '/v2/settings/comment', config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }

  async updateAutoLikeCommentFacebook(data) {
    return await axios
      .put(GOCHAT_URL + '/v2/settings/comment', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error.message;
      });
  }
}

class CustomerList {
  async getCustomerList(data) {
    return await axios
      .get(GOCHAT_URL + '/v2/customers' + data, config)
      .catch(error => {
        throw error;
      });
  }
  async viewCustomerListByID(customerID) {
    return await axios
      .get(GOCHAT_URL + `/v2/customers/${customerID}/view`, config)
      .catch(error => {
        throw error;
      });
  }
}

class DeletionList {
  async getConfirmationDeletionList(data = '') {
    return await axios
      .get(GOCHAT_URL + '/v2/deletion' + data, config)
      .catch(error => {
        throw error;
      });
  }
}

function handleApiError(promise) {
  return promise.catch(error => {
    if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
    else throw error;
  });
}

class AiSettings {
  async getSettings() {
    return handleApiError(axios.get(GOCHAT_URL + '/v2/settings/ai', config));
  }
  async saveSettings(data) {
    return handleApiError(axios.put(GOCHAT_URL + '/v2/settings/ai', data, config));
  }
  async syncProducts() {
    return handleApiError(axios.post(GOCHAT_URL + '/v2/settings/ai/products/sync', {}, config));
  }
  async getSyncStatus() {
    return handleApiError(axios.get(GOCHAT_URL + '/v2/settings/ai/products/sync-status', config));
  }
  async getProducts(params = {}) {
    return handleApiError(axios.get(GOCHAT_URL + '/v2/settings/ai/products', { params, headers: config.headers }));
  }
  async getCategories() {
    return handleApiError(axios.get(GOCHAT_URL + '/v2/settings/ai/products/categories', config));
  }
  async getTags() {
    return handleApiError(axios.get(GOCHAT_URL + '/v2/settings/ai/products/tags', config));
  }
  async mapProducts(gosaas_product_ids) {
    return handleApiError(axios.post(GOCHAT_URL + '/v2/settings/ai/products/map', { gosaas_product_ids }, config));
  }
  async unmapProduct(gosaas_product_id) {
    return handleApiError(axios.delete(GOCHAT_URL + `/v2/settings/ai/products/map/${gosaas_product_id}`, config));
  }
  async getFaq() {
    return handleApiError(axios.get(GOCHAT_URL + '/v2/settings/ai/faq', config));
  }
  async createFaq(data) {
    return handleApiError(axios.post(GOCHAT_URL + '/v2/settings/ai/faq', data, config));
  }
  async updateFaq(faqId, data) {
    return handleApiError(axios.put(GOCHAT_URL + `/v2/settings/ai/faq/${faqId}`, data, config));
  }
  async deleteFaq(faqId) {
    return handleApiError(axios.delete(GOCHAT_URL + `/v2/settings/ai/faq/${faqId}`, config));
  }
  async getAgentJson() {
    return handleApiError(axios.get(GOCHAT_URL + '/v2/settings/ai/agent-json', config));
  }
  async testChat(data) {
    return handleApiError(axios.post(GOCHAT_URL + '/v2/settings/ai/test-chat', data, config));
  }
}

class Shopee {
  async getStickers(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/stickers', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
  async getProducts(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/shopee-products', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
}

class Tiktok {
  async getProducts(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/tiktok-products', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
}

class Lazada {
  async getProducts(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/lazada-products', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
}

class Payment {
  /**
   * Verify payment slip via GoPay API — verify-by-URL flow (no payment_id required pre-create).
   * Result is cached client-side and bound to OrderPayment at order-create time.
   * @param {Object} data - Verification data
   * @param {string} data.image_url - Slip image URL (required)
   * @param {number} data.amount - Expected amount (required)
   * @param {string|number} data.bank_account_id - Bank account ID
   * @param {string} [data.order_no] - Order number (blank pre-create)
   * @returns {Promise<Object>} Verification result
   */
  async verifySlip(data) {
    return await axios
      .post(GOCHAT_URL + '/v2/payment/verify-slip', data, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }

  /**
   * Get payment details by ID (post-create read-back).
   * @param {string} paymentId - Payment ID
   * @returns {Promise<Object>} Payment data
   */
  async getPayment(paymentId) {
    return await axios
      .get(GOCHAT_URL + `/v2/payment/${paymentId}`, config)
      .catch(error => {
        if (error.response && (error.response.status == 401 || error.response.data.message == "Authentication failed.")) gotoLoginGoSaas();
        else throw error;
      });
  }
}

export default {
  Address: new Address(),
  Merchant: new Merchant(),
  Chat: new Chat(),
    AUTH: {
      TOKEN: GOCHAT_TOKEN,
      URL: GOCHAT_URL,
    },
    URL: {
      // PRODUCT: API_PRODUCT,
    },
  FrequentlyMsg: new FrequentlyMsg(),
  Note: new Note(),
  PaymentMethods: new PaymentMethods(),
  Bank: new Bank(),
  Product: new Product(),
  Tags: new Tags(),
  LinkDetails: new LinkDetails(),
  Facebook: new Facebook(),
  ConversionAPIReport: new ConversionAPIReport(),
  CustomerList: new CustomerList(),
  DeletionList: new DeletionList(),
  AiSettings: new AiSettings(),
  Shopee: new Shopee(),
  Tiktok: new Tiktok(),
  Lazada: new Lazada(),
  Payment: new Payment(),
}



// WEBPACK FOOTER //
// ./src/services/endpoint/central.service.js